<template>
  <v-form class="dark" ref="form">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="itemData.clubCode"
                label="Club Code"
                :rules="nameRules"
                :counter="50"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="itemData.clubName"
                label="Club Name"
                :rules="nameRules"
                :counter="50"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="itemData.clubDesc"
                label="Club Desc"
                :rules="nameRules"
                :counter="50"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="itemData.logo"
                label="Logo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                dense
                type="number"
                :rules="latLngRules"
                v-model.number="itemData.latitude"
                outlined
                label="Latitude"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                dense
                type="number"
                :rules="latLngRules"
                v-model.number="itemData.longitude"
                outlined
                label="Longitude"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                outlined
                dense
                hide-details
                class="hidden-xs-only"
                v-model="itemData.countryId"
                :items="countryList"
                label="Country"
                :rules="requiredRule"
                item-value="node.valId"
                item-text="node.valDesc"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="itemData.year"
                    label="Year"
                    prepend-inner-icon="event"
                    v-on="on"
                    v-bind="attrs"
                    readonly
                    no-title
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="itemData.createDate"
                  :active-picker.sync="activePicker"
                  @click:year="setYear"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-switch
                color="secondary"
                v-model="itemData.visibility"
                label="Visibility"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close">Cancel</v-btn>
        <v-btn color="secondary" text @click="actionName">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import moment from "moment";
import {
  defaultClubData,
  clubsTableHeaders,
  clubNameValidationRules,
  clubRequiredValidationRules,
  paginationSettings,
  regLatLngNumberValidationRule,
} from "@/constants/clubs";
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    editData: {
      type: [Boolean, Object],
    },
  },
  data() {
    return {
      itemData: {
        clubCode: "",
        clubName: "",
        clubDesc: "",
        countryId: 0,
        logo: "",
        latitude: null,
        longitude: null,
        year: null,
        visibility: 0,
        createDate: "",
      },
      defaultItem: defaultClubData,
      activePicker: null,
      isFormValid: true,
      dialog: false,
      menu: false,
      nameRules: clubNameValidationRules,
      requiredRule: clubRequiredValidationRules,
      latLngRules: regLatLngNumberValidationRule,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  methods: {
    ...mapActions(["addClub", "allClubs", "clubDelete", "editClub"]),
    // /**
    //  * @param {Int} id
    //  */
    // editItem(item) {
    //   this.dialog = true;
    //   this.itemData = Object.assign({}, item);
    //   this.editedIndex = 1;
    // },
    // deleteClub(id) {
    //   this.clubDelete(id).then(() => {
    //     this.$toast.error("Club has been deleted");
    //   });
    // },
    close() {
      this.dialog = false;
      this.itemData = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.$emit("close-club");
    },
    addNewClub() {
      if (this.$refs.form.validate()) {
        this.addClub({
          ...this.itemData,
          password: String("SportEcoSys123!"),
          createDate: String(
            this.itemData.createDate.length > 0
              ? this.itemData.createDate
              : this.moment.format("YYYY-MM-DD")
          ),
          year: Number(this.itemData.year),
          updateSource: "VueJS tst",
        }).then(() => {
          this.close();
          this.$toast.success("Club has been added");
        });
      }
    },
    // editClubInfo() {
    //   this.editClub({
    //     ...this.itemData,
    //     clubId: +this.itemData.clubId,
    //     password: String("SportEcoSys123!"),
    //     createDate: String(
    //       this.itemData.createDate.length > 0
    //         ? this.itemData.createDate
    //         : this.moment.format("YYYY-MM-DD")
    //     ),
    //     updateSource: "VueJS tst",
    //   }).then(() => {
    //     this.dialog = false;
    //     this.editableId = -1;
    //     this.itemData = Object.assign({}, this.defaultItem);
    //     this.$toast.info("Club has been edited");
    //   });
    // },
    setYear(data) {
      this.itemData.year = data;
      this.itemData.createDate = moment(new Date(data, "0", "1")).format(
        "YYYY-MM-DD"
      );
      this.menu = false;
    },
  },
  computed: {
    ...mapGetters(["loading", "categoryValue"]),
    actionName() {
      return this.editedIndex > 0 ? this.editClubInfo : this.addNewClub;
    },
    countryList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          (category) => category.node.category.catName === "COUNTRY_LIST"
        );
      }
    },
  },
};
</script>
